import styled from 'styled-components';

export const AircraftGeneralContainer = styled.div`
  width: auto;

  > section {
    margin-bottom: 7px;
  }

  .aircraftMeta {
    display: flex;
    flex-wrap: wrap;
  }

  .aircraftMetaModal {
    position: relative;
    bottom: 35px;
  }

  @media (min-width: 1024px) {
    margin-top: -100px;
    width: calc(50% - 30px);
  }
`;
